// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Clock: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M27.3 28.7H12.6c-.6 0-1-.4-1-1s.4-1 1-1h14.1l4.8-7.8c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4l-5.1 8.2c-.2.3-.5.5-.8.5z"/><path d="M27.5 51.7c-13.3 0-24.2-10.9-24.2-24.2 0-13.3 10.9-24.2 24.2-24.2s24.2 10.9 24.2 24.2c0 13.3-10.9 24.2-24.2 24.2zm0-46.4c-12.2 0-22.2 10-22.2 22.2s10 22.2 22.2 22.2 22.2-10 22.2-22.2-10-22.2-22.2-22.2z"/></svg>;
};

export default React.memo(Clock);
